import { Icon } from '@equinor/eds-core-react'
import { report_bug } from '@equinor/eds-icons'
import { VulnerabilitySummary } from '../../../vulnerability-summary'
import { StatusPopover } from '../../status-popover'
import {
  getStatusPopoverType,
  hasAnyVulnerabilities,
  hasVisibleVulnerabilities,
  VISIBLE_VULNERABILITY_SEVERITIES,
  type VulnerabilityCounts,
} from './vulnerabilityStatusPopover.utils'

interface VulnerabilityStatusPopoverProps {
  readonly summary: VulnerabilityCounts
}

export const VulnerabilityStatusPopover = ({ summary }: VulnerabilityStatusPopoverProps) => {
  if (!hasAnyVulnerabilities(summary) || !hasVisibleVulnerabilities(summary, VISIBLE_VULNERABILITY_SEVERITIES)) {
    return null
  }

  const type = getStatusPopoverType(summary)

  return (
    <StatusPopover title={'Vulnerabilities'} icon={<Icon data={report_bug} />} type={type}>
      <div className="grid grid--gap-x-small grid--auto-columns">
        <VulnerabilitySummary summary={summary} visibleKeys={VISIBLE_VULNERABILITY_SEVERITIES} />
      </div>
    </StatusPopover>
  )
}
